import { render, staticRenderFns } from "./addOrEditDialog.vue?vue&type=template&id=5b879b19&scoped=true&"
import script from "./addOrEditDialog.vue?vue&type=script&lang=js&"
export * from "./addOrEditDialog.vue?vue&type=script&lang=js&"
import style0 from "./addOrEditDialog.vue?vue&type=style&index=0&id=5b879b19&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b879b19",
  null
  
)

export default component.exports